import NewClassImages from './View/NewClassImages.view';
export default NewClassImages;
